import { Component } from '@theme/component';
import { DialogComponent } from '@theme/dialog';
import { PartnerUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a Partner/Referral Details modal.
 */
class ReferralDetails extends Component {
  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Handles the change partner button click event.
   * @param {Event} event - The event.
   */
  async handleChangePartner(event) {
    await this.#closeCurrentDialog();
    
    this.#showDialogById('referral-finder-modal');
  }

  /**
   * Handles the remove partner button click event.
   * @param {Event} event - The event.
   */
  async handleRemovePartner(event) {
    document.dispatchEvent(new PartnerUpdateEvent(null));
    
    this.#closeCurrentDialog();
  }

  /**
   * Closes the current dialog.
   */
  async #closeCurrentDialog() {
    const dialogComponent = this.closest('dialog-component');
    if (dialogComponent instanceof DialogComponent) {
      await dialogComponent.closeDialog();
    }
  }

  /**
   * Opens a dialog based on a given dialog ID.
   * @param {string} dialogId - The dialog ID.
   */
  #showDialogById(dialogId) {
    const dialogComponent = document.getElementById(dialogId);
    if (dialogComponent instanceof DialogComponent) {
      dialogComponent.showDialog();
    }
  }
}

if (!customElements.get('referral-details-component')) {
  customElements.define('referral-details-component', ReferralDetails);
}